// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueCookie from 'vue-cookie';

import Filter from '../../assets/js/filter.js';
import Router from '../../router';
import MBAjax from '../../assets/js/mb_ajax.js';
import Util from '../../assets/js/util.js';
import { Message } from 'element-ui';
import store from '../../store';
import Toast from '../../plugins/toast';

import App from '../../v2/main/App';

// force show
let showHomePage = false;
let appType = Util.getUrlParam('type') || 'wps';
// document.domain = 'wps.com';
document.getElementById('body').className = `docer-${appType}`;

Vue.use(VueResource);
Vue.use(MBAjax, { type: appType });
Vue.prototype.$message = Message;
Vue.config.productionTip = false;

// set global object
window.AppInfo = { setted: false };
window.jscallback = {};
window.runContanainer = window.cefQuery ? "cef" : window.homepageapi ? "webkit" : "browser";
window.excApi = function(e) {
    if (window.cefQuery) {
        let n = `jsAsynCall(${e})`;
        return window.cefQuery({
            request: n,
            persistent: !1
        });
    } else if (window.homepageapiasync || window.homepageapi) {
        return (window.homepageapiasync || window.homepageapi).jsAsynCall(e);
    } else {
        Util.capture('log', 'not in webview');
        return false;
    }
};
if (window.Raven) {
    Raven
        .config('http://059a8e1753cd4a47ad8c35232dfa9f9c@120.92.93.69:9001/16')
        .install();
};

// new vue instance for global events
window.VEvts = new Vue();
window.changeOpenStatus = function() {
    if (showHomePage) { return; }
    showHomePage = true;

    let killEvent = function(e) {
        e.preventDefault();
        e.stopPropagation();
    };
    // mouse-select diasble
    document.addEventListener('selectstart', function(e) {
        killEvent(e);
        return false;
    });
    // mouse-wheel diasble
    document.addEventListener('mousedown', function(e) {
        if (e.button === 1 || e.buttons === 4 || e.which === 2) {
            killEvent(e);
            return false;
        }
    });

    document.addEventListener('click', function(e) {
        e = e || window.event;
        let target = e.target || e.srcElement;
        let _g = target.getAttribute('ga');
        let args, cate, act, label;

        if (_g) {
            args = _g.split(';');
            cate = args[0] || 'homepage';
            act = args[1] || 'click';
            label = args[2] || AppInfo.ver;
            Util.gaReport('send', 'event', cate, act, label);
        }
    });

    // get appinfo & init vue
    Util.jsAsynCall('getWpsVersionInfo', true)
        .then(function(res) {
            console.log('set app info', res);
            window.AppInfo = {
                setted: true,
                type: appType,
                ver: res.version,
                disnum: res.channelid,
                guid: res.guid,
                hdid: res.hdid,
                uuid: res.uuid,
                isGdpr: res.isGdpr || false,
                isUwp: res.isUwp || false,
            };

            Util.gaReport('create', 'UA-65686656-12', {
                'clientId': AppInfo.guid,
                'sampleRate': 5
            });

            let pathInfo = `/home/${appType}`;
            Util.gaReport('set', 'page', pathInfo);
            Util.gaReport('set', 'appName', 'homepage');
            Util.gaReport('set', 'appVersion', AppInfo.ver);
            Util.gaReport('set', 'dimension1', AppInfo.disnum);
            Util.gaReport('set', 'dimension2', window.runContanainer);
            Util.gaReport('set', 'gdpr', +AppInfo.isGdpr);
            Util.gaReport('set', 'uwp', +AppInfo.isUwp);
            Util.gaReport('send', 'pageview');
            // 通过修改时间来确认cdn刷新的覆盖率
            Util.gaReport('send', 'event', '/homepage', 'Show', '2018-01-09');

            projectInit();
        })
        .catch(function(err) {
            window.AppInfo = {
                setted: true,
                type: appType,
                ver: '0.0.0.0',
                disnum: '12345.12345678'
            };

            projectInit();
        });
};
window.notifyIsLogined = (function() {
    return function(data, wpsKey, user, memberid) {
        var isLogin = eval('(' + data + ')');

        // trigger global event for user status change
        VEvts.$emit('LOGIN_CHANGE', {
            isLogin: isLogin,
            userInfo: {
                data: data,
                wpsKey: wpsKey,
                user: user,
                memberid: memberid
            }
        });
    };
})();
// 夜间模式
window.setAlphaMask = function(e) {
    var elem_body = document.getElementById('body');
    if (e <= 0) {
        elem_body.style.background = '#f7f7f7';
        elem_body.style.opacity = 1;
    } else {
        elem_body.style.background = '#000';
        elem_body.style.opacity = ((256 - e) / 256);
    }
};
window.onload = function() {
    Util.gaReport('send', 'timing', '/homepage', 'load', new Date() - window._start);
};

// show homepage
Util.jsAsynCall('showHomePage');

function projectInit() {
    Vue.use(Toast);
    new Vue({
        el: '#app',
        store,
        router: Router,
        template: '<App/>',
        components: { App },
        filters: Filter,
    });
};
//  for qt/broswer
setTimeout(function() {
    window.changeOpenStatus();
}, 200);



// WEBPACK FOOTER //
// ./app/pages/index/index.js